/**
 * Chaps PDP — video toggle, thumbnail switcher, qty stepper
 * Single file, no duplicate bindings
 */
(function () {
  'use strict';

  function init() {

    // ── QUANTITY STEPPER ──
    // Use event delegation on document so it works even if DOM changes
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-chaps-qty-action]');
      if (!btn) return;
      var action = btn.getAttribute('data-chaps-qty-action');
      var qtyWrap = btn.closest('[data-chaps-qty]');
      if (!qtyWrap) return;
      var input = qtyWrap.querySelector('.chaps-qty__input');
      if (!input) return;
      var current = parseInt(input.value, 10) || 1;
      if (action === 'minus') {
        input.value = Math.max(1, current - 1);
      } else if (action === 'plus') {
        input.value = current + 1;
      }
    });

    // ── THUMBNAIL SWITCHER ──
    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-chaps-media-id]');
      if (!thumb) return;
      var sectionId = thumb.getAttribute('data-section');
      var mediaId = thumb.getAttribute('data-chaps-media-id');

      // Show/hide media items in this section
      var section = document.querySelector('[data-section-id="' + sectionId + '"]');
      if (!section) return;

      section.querySelectorAll('.chaps-pdp__media-item').forEach(function (item) {
        item.classList.toggle('chaps-hidden', item.getAttribute('data-media-item-id') !== mediaId);
      });

      section.querySelectorAll('.chaps-thumb').forEach(function (t) {
        t.classList.toggle('chaps-thumb--active', t.getAttribute('data-chaps-media-id') === mediaId);
      });
    });

    // ── PHOTO / VIDEO TOGGLE ──
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-chaps-toggle]');
      if (!btn) return;
      var mode = btn.getAttribute('data-chaps-toggle');
      var sectionId = btn.getAttribute('data-section');
      var section = document.querySelector('[data-section-id="' + sectionId + '"]');
      if (!section) return;

      var mediaWrap = document.getElementById('chaps-media-wrap-' + sectionId);
      var videoPanel = document.getElementById('chaps-video-panel-' + sectionId);

      // Update toggle button states
      section.querySelectorAll('[data-chaps-toggle]').forEach(function (b) {
        b.classList.toggle('chaps-media-toggle__btn--active', b.getAttribute('data-chaps-toggle') === mode);
      });

      if (mode === 'video' && videoPanel) {
        if (mediaWrap) mediaWrap.classList.add('chaps-hidden');
        videoPanel.classList.remove('chaps-hidden');
        var vid = videoPanel.querySelector('video');
        if (vid) vid.play().catch(function () {});
      } else {
        if (videoPanel) {
          videoPanel.classList.add('chaps-hidden');
          var vid = videoPanel.querySelector('video');
          if (vid) { vid.pause(); vid.currentTime = 0; }
        }
        if (mediaWrap) mediaWrap.classList.remove('chaps-hidden');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
